<template>
  <ResidentialApartmentsList
    :onApartmentClick="this.onApartmentClick"
    :floorsPlan="this.floorsPlan"
    :getFloorData="this.getFloorData"
    :updateData="this.onFloorsPlanUpdate"
    :showCheckbox="this.tab === 'M__ProjectFormDocumentTab'"
    :mode="this.tab === 'M__ProjectFormDocumentTab' ? 'group' : ''"
  />
</template>

<script>
import ResidentialApartmentsList from './ResidentialApartmentsList.vue';

export default {
  name: "EntranceSchema",
  props: ['onApartmentClick', 'floorsPlan', 'onFloorsPlanUpdate', 'tab', 'getFloorData'],
  components: {
    ResidentialApartmentsList
  },
};
</script>

<style scoped></style>
